import api from '../api';

export const GetPhotoPerfil = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get('/v1/Cliente/GetPhoto', {
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'image/png',
            },
        });

        if (data?.size > 0) {
            const url = window.URL.createObjectURL(data);

            return { data: url };
        } else {
            return { data: null };
        }

    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
